import {routes as patBem} from '../patrimonio/patbem'
import {routes as patEstadoConservacao} from '../patrimonio/patestadoconservacao'
import {routes as patFormaTombamento} from '../patrimonio/patformatombamento'
import {routes as patGrupoBem} from '../patrimonio/patgrupobem'
import {routes as patMotivoBaixa} from '../patrimonio/patmotivobaixa'
import {routes as patTipoBem} from '../patrimonio/pattipobem'
import {routes as patAlocacao} from '../patrimonio/patalocacao'
import {routes as patResponsavel} from '../patrimonio/patresponsavel'
import {routes as relatorioBem} from '../patrimonio/relatoriobem'
import {routes as relatorioBaixa} from '../patrimonio/relatoriobaixa'
import {routes as relatorioPlanejamentoInventario} from '../patrimonio/relatorioplanejamentoinventario'
import {routes as patInventarioEncerramento} from '../patrimonio/patinventarioencerramento'
export default [
  {
    path: '/patrimonio',
    name: 'Patrimonio',
    description: 'Módulo Patrimonio',
    children: [
      ...patBem,
      ...patEstadoConservacao,
      ...patFormaTombamento,
      ...patGrupoBem,
      ...patMotivoBaixa,
      ...patTipoBem,
      ...patAlocacao,
      ...patResponsavel,
      ...relatorioBem,
      ...relatorioBaixa,
      ...relatorioPlanejamentoInventario,
      ...patInventarioEncerramento,
     ],
    goesToMenu: true
  }
]
